import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserModel } from 'app/_models/user-model';
import { EncryptionService } from 'app/_services/encryption.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private readonly encryptDecryptService: EncryptionService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser: UserModel | null = sessionStorage['user'] ? JSON.parse(sessionStorage['user']) : null;
    
    if (currentUser) {
      const sessionId = this.encryptDecryptService.decrypt(currentUser.transientCode);
      
      const modifiedRequest = request.clone({
        withCredentials: true,
        headers: request.headers
          .set('Cache-Control', 'no-cache')
          .set('Pragma', 'no-cache')
          .set('Expires', '0')
          .set('X-User-Id', currentUser.userId)
          .set('sessionId', sessionId)
          .set('X-App-Request', 'AngularClient')
          .set('X-LoggedIn-Id', currentUser.loggedInId)
          .set('X-User-Roles', currentUser.roles.toString())
      });

      return next.handle(modifiedRequest);
    }

    return next.handle(request.clone({ withCredentials: true }));
  }
}
